import {
  Container,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import React, { FC, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ToolDisposalPage } from "./toolDisposalRequests/toolDisposalPage";
import { NotFoundPage } from "./notFound";
import { NewRequestPage } from "./toolDisposalRequests/newRequestToolDisposal/newRequestPage";
import { isDashboardTourOpen } from "../src/toolDisposalRequests/toolDisposalSlice";
import { isNewRequestTourOpen } from "../src/toolDisposalRequests/toolDisposalSlice";

import { useDispatch } from "react-redux";

export const AppRoutes: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    const visited = localStorage["alreadyVisited"];
    const visitedRequest = localStorage["alreadyVisitedRequestPage"];
    if (!visited) {
      localStorage["alreadyVisited"] = true;
      dispatch(isDashboardTourOpen(true));
    }
    if (!visitedRequest) {
      localStorage["alreadyVisitedRequestPage"] = true;
      dispatch(isNewRequestTourOpen(true));
    }
  }, []);

  return (
    <Container className={classes.root} maxWidth={"xl"}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/tool-disposal" element={<ToolDisposalPage />} />
        <Route path="/disposal-request/:requestId" element={<NewRequestPage />} />
        <Route path="/disposal-request" element={<NewRequestPage />} />
        <Route path="/not-found" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Routes>
    </Container>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    "& .shepherd-theme-custom": {
      background: "white !important",
    },
    "& .shepherd-content": {
      background: "white",
    },
    root: {
      maxWidth: "1440px",
      margin: "auto",
      padding: theme.spacing(3),
    },
  })
);
